import { BaseDataService, QueryParameter, CollectionService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { BaseUpdateComponent } from 'yt-ng-framework';
import { PodVrstaDokumentaStavka } from './podvrste-dokumenta-stavka';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators, FormGroup, Form } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { VrstaDokumenta } from '../vrsta-dokumenta/vrsta-dokumenta';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Osoba } from '../osoba/osoba';
import { PodVrstaDokumenta } from '../podvrste-dokumenta/podvrste-dokumenta';
import { Company } from 'src/app/admin/company/company';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-podvrste-dokumenta-stavka-update',
  templateUrl: './podvrste-dokumenta-stavka-update.component.html'
})

export class PodVrsteDokumentaStavkaUpdateComponent 
extends BaseUpdateComponent<PodVrstaDokumentaStavka> 
implements OnInit {

  parameterList: List<QueryParameter> = List([]);
  VrstaDokumentaID: QueryParameter = new QueryParameter();
  parameterListForIzvestaj: List<QueryParameter> = List([]);
  PodVrstaDokumentaID: QueryParameter = new QueryParameter();
  // @ViewChild('idFormatBrojaPrimer') idFormatBrojaPrimer: ElementRef;
  // @ViewChild('idFormatBroja') idFormatBroja: ElementRef;

  constructor(
    public collectionService: CollectionService,
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  // vrstaDokumentaItems: List<VrstaDokumenta>;
  selectedVrstaDokumentaItem: VrstaDokumenta;
  jesteAdmin : boolean = false;
  hideBankaID: boolean = false;
  odgovornoLice : string; 
  datum: NgbDate;
  prikaziDatum: string;
  primerBrojDokumenta: string;
  hidePrimerStampe: boolean = true;
  primerStampeTekst: string = "Prikaži primer";
  prikaziFooter: string;
  odgovornoLiceJeObavezno: boolean = false;
  odgovornoLiceId: any;
  items : any;
  hideBrojDecimala: boolean = false;
  trenutniBrojDecimala: number;
  izmenjeniBrojDecimala: any;

  duzinaBrojaEnable: boolean = true;
  tooltipDuzinaBrojaDokumentaEnabled: string = "PODVRSTADOKUMENTASTAVKA.DUZINABROJA.TOOLTIP.ENABLED";
  tooltipDuzinaBrojaDokumentaDisabled: string;
  tooltipBrojDecimalaDisabled: string;
  brojDecimalaEnable: boolean = true;
  tooltipBrojDecimalaEnabled: string = "PODVRSTADOKUMENTASTAVKA.BROJDECIMALA.TOOLTIP.ENABLED";
  @Input() Parameters;

  ngOnInit() {
    super.ngOnInit();

    this.VrstaDokumentaID.Name="vrstadokumentaid";
    this.VrstaDokumentaID.Value=-1;
    this.parameterList = this.parameterList.push(this.VrstaDokumentaID);

    this.PodVrstaDokumentaID.Name="podvrstadokumentaid";
    this.PodVrstaDokumentaID.Value=1;
    this.parameterListForIzvestaj = this.parameterListForIzvestaj.push(this.PodVrstaDokumentaID);

    this.addValidatorToFc("PodVrstaDokumentaID", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.PODVRSTADOKUMENTA.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.NAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.maxLength(200), "maxlength", "PODVRSTADOKUMENTASTAVKA.NAZIV.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("Sifra", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.SIFRA.VALIDATION.REQUIRED");
    this.addValidatorToFc("Sifra", Validators.maxLength(3), "maxlength", "PODVRSTADOKUMENTASTAVKA.SIFRA.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("Footer1", Validators.maxLength(2000), "maxlength", "PODVRSTADOKUMENTASTAVKA.FOOTER1.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("FormatBrojaDokumenta", Validators.maxLength(50), "maxlength", "PODVRSTADOKUMENTASTAVKA.FORMATBROJADOKUMENTA.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("DefaultIzvestajID", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.DEFAULTIZVESTAJ.VALIDATION.REQUIRED");
    this.addValidatorToFc("BrojDecimala", Validators.max(7), "max", "PODVRSTADOKUMENTASTAVKA.BROJDECIMALA.VALIDATION.MAX");
    // this.addValidatorToFc("BankaID", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.PODVRSTADOKUMENTA.VALIDATION.REQUIRED");
    // this.baseFormGroup.setValidators(daLiJeBrojDecimalaVeciOdOsam('BrojDecimala'));
    // this.baseFormGroup.updateValueAndValidity();
    // this.baseFormGroup.setValidators(checkBrojDecimala(this,'BrojDecimala'));
    // this.baseFormGroup.updateValueAndValidity();

    // this.baseFormGroup.setValidators(CheckOdgovornoLice('OdgovornoLiceID','PodVrstaDokumentaID',this));

    
    // this.baseFormGroup.updateValueAndValidity();

    //this.addValidatorToFc("Oznaka", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.OZNAKA.VALIDATION.REQUIRED");
   // this.addValidatorToFc("Oznaka", Validators.maxLength(20), "maxlenght", "PODVRSTADOKUMENTASTAVKA.OZNAKA.VALIDATION.MAXLENGHT");
   this.IDProcessed
    .subscribe((value)=>{
      if (value){
        
        if (this.Item.ID == -1){
          if (this.Parameters){
            let id = this.Parameters.get(0).Value;
            this.baseDataService.GetByID('PodVrstaDokumentaStavka',id,PodVrstaDokumentaStavka)
            .subscribe((item: PodVrstaDokumentaStavka)=>{
              if (item.BankaID == null){
                this.baseFormGroup.patchValue({PodVrstaDokumentaID : item.PodVrstaDokumentaID});
                this.baseFormGroup.get('PodVrstaDokumentaID').disable();
                this.baseFormGroup.get('PodVrstaDokumentaID').updateValueAndValidity();
              }      
              this.baseFormGroup.patchValue({VrstaDokumentaID : item.VrstaDokumentaID});
              this.baseFormGroup.get('VrstaDokumentaID').disable();
              this.baseFormGroup.get('VrstaDokumentaID').updateValueAndValidity();
            })
          }
          //  if (this.Parameters){
          //   let id = this.Parameters.get(0).Value;
          //   this.baseDataService.GetByID('PodVrstaDokumentaStavka',id,PodVrstaDokumentaStavka)
          //   .subscribe((item: PodVrstaDokumentaStavka)=>{
          //     if (item.BankaID == null){
          //       this.baseFormGroup.patchValue({PodVrstaDokumentaID : item.PodVrstaDokumentaID});
          //       this.baseFormGroup.get('PodVrstaDokumentaID').disable();
          //       this.baseFormGroup.get('PodVrstaDokumentaID').updateValueAndValidity();
          //     }      
          //     this.baseFormGroup.patchValue({VrstaDokumentaID : item.VrstaDokumentaID});
          //     this.baseFormGroup.get('VrstaDokumentaID').disable();
          //     this.baseFormGroup.get('VrstaDokumentaID').updateValueAndValidity();
          //   })
          // }

          this.baseDataService.Get('firma', 'GetCompanyId', null, Company)
          .subscribe(data => {
            if(data['OdgovornoLiceID']>0){
              this.baseFormGroup.patchValue({OdgovornoLiceID : data['OdgovornoLiceID']});
              this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
            }
          })
          
          this.baseFormGroup.patchValue({Aktivan: true})
          this.baseFormGroup.get('Aktivan').updateValueAndValidity();

          this.hideBankaID = true;
          this.hideBrojDecimala = true;
        }else{
          this.baseFormGroup.get('Sifra').disable();
          this.trenutniBrojDecimala = this.Item.BrojDecimala;

         // this.baseFormGroup.setValidators(daLiJeBrojDecimalaVeciOdOsam('BrojDecimala'));
          
          //dobijanje broja podataka koji su u prometu za podvrsta dokumenta
          this.baseDataService.Get("PodvrstaDokumentaStavka", "getBrojDokumenataUPrometu", [new QueryParameter("podvrstaDokumentaStavkaId",this.Item.ID)], null)
            .subscribe((broj: any) => {
              this.items = broj;
              //ukoliko postoje dokumenti u prometu duzina broja se disable-uje i postavlja se odgovarajuci tooltip
              if(this.items > 0){
                this.baseFormGroup.get('DuzinaBrojaDokumenta').disable();
                this.duzinaBrojaEnable = false;
                this.tooltipDuzinaBrojaDokumentaDisabled = "PODVRSTADOKUMENTASTAVKA.DUZINABROJA.TOOLTIP.DISABLED"
                //ukoliko je broj decimala 7 i postoje dokumenti u prometu disevluje se kontrola za broj decimala i postavlja odgovarajuci tooltip
                if(this.trenutniBrojDecimala==7){
                this.baseFormGroup.get('BrojDecimala').disable();
                this.brojDecimalaEnable = false;
                this.tooltipBrojDecimalaDisabled = "PODVRSTADOKUMENTASTAVKA.BROJDECIMALA.TOOLTIP.DISABLED"
                }

                this.baseFormGroup.setValidators(checkBrojDecimala(this,'BrojDecimala'));
              
              }
            })
         
          //  this.baseFormGroup.get('BrojDecimala').updateValueAndValidity;
            
          
        }

        if (this.baseFormGroup.get('VrstaDokumentaID').value!=null){
          this.VrstaDokumentaID.Value=this.baseFormGroup.get('VrstaDokumentaID').value;
          this.VrstaDokumentaID.Name="vrstadokumentaid";
          if (this.VrstaDokumentaID.Value!=null){
            this.parameterList=List([]);
            this.parameterList = this.parameterList.push(this.VrstaDokumentaID);
          }
        }

        if (this.baseFormGroup.get('PodVrstaDokumentaID').value!=null){
            this.PodVrstaDokumentaID.Value=this.baseFormGroup.get('PodVrstaDokumentaID').value;
            this.PodVrstaDokumentaID.Name="podvrstadokumentaid";
            if (this.PodVrstaDokumentaID.Value!=null){
              // this.baseDataService.Get("podvrstadokumenta","get",[new QueryParameter('id',this.PodVrstaDokumentaID.Value)],PodVrstaDokumenta)
              //   .subscribe((data) => {
              //     this.odgovornoLiceJeObavezno = data['OdgovornoLiceJeObavezno'];
            
              //   }) 
              this.parameterListForIzvestaj=List([]);
              this.parameterListForIzvestaj = this.parameterListForIzvestaj.push(this.PodVrstaDokumentaID);
            }
              
          }
          // let formatBrojaDokumenta: string = this.baseFormGroup.get('FormatBrojaDokumenta').value;
          // let duzinaBrojaDokumenta: number;
          // duzinaBrojaDokumenta = formatBrojaDokumenta.split("[")[1].split("]")[0].length;
        // else{
        //     this.VrstaDokumentaID.Name="vrstadokumentaid";
        //     this.VrstaDokumentaID.Value=-1;
        //     this.parameterList = this.parameterList.push(this.VrstaDokumentaID);
        //   }
        }

        
        
    })

    // this.loadVrstaDokumentaItems();
  }

  // private loadVrstaDokumentaItems(){
  //   this.baseDataService.Get('vrstadokumenta','get',[],VrstaDokumenta)
  //   .subscribe((data) => {
  //     this.vrstaDokumentaItems = this.collectionService.SortItems(List(data), "ID", false);
  //   })

  // }
 
  pamtiVrednostVrstaDokumentID: number;
  onVrstaDokumentaSelect(value : VrstaDokumenta){
    if (value){
      //this.VrstaDokumentaID.Value=value;
     //let parameterList: List<QueryParameter> = List([new QueryParameter('VrstaDokumentaID', value)]);
     // let parameterList: List<QueryParameter> = List([new QueryParameter(this.VrstaDokumentaID.Value)]);
     if(this.pamtiVrednostVrstaDokumentID && this.pamtiVrednostVrstaDokumentID!=value.ID){
      this.baseFormGroup.patchValue({PodVrstaDokumentaID:null});
      this.baseFormGroup.get("PodVrstaDokumentaID").updateValueAndValidity();
     }
      this.parameterList=List([]);
      this.VrstaDokumentaID.Name="vrstadokumentaid";
      this.VrstaDokumentaID.Value=value.ID;
      this.parameterList = this.parameterList.push(this.VrstaDokumentaID)
      this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
      this.pamtiVrednostVrstaDokumentID=value.ID;

      if (value.GenericName == "izv_banke"){
        this.hideBankaID = false;
        this.setBankaIDValidation(true); 
      }
      else{
        this.hideBankaID = true;
        this.setBankaIDValidation(false); 
      }

      if(value.GenericName == "rob_iz_dok" || value.GenericName == "av_rac" || value.GenericName == "ul_dok" || value.GenericName == "rob_pred" || value.GenericName == "ponuda" || value.GenericName == "knj_pismo"){
        this.hideBrojDecimala = false;
      }else{
        this.hideBrojDecimala = true;
      }
    }
  }

  setBankaIDValidation(isRequired: boolean) {
    const bankaControl = this.baseFormGroup.get('BankaID');
  
    if (bankaControl) {
      if (isRequired) {
        this.addValidatorToFc("BankaID", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.BANKA.VALIDATION.REQUIRED");
      } else {
        bankaControl.clearValidators();
      }
  
      bankaControl.updateValueAndValidity();
    }
  }

  onDuzinaBrojaChange(value){
    let duzina = value;
    let sifra= this.baseFormGroup.get('Sifra').value;
    let godina = new Date().getFullYear().toString();
    if (duzina!=null && sifra!=null)
    {
        let format_primer = sifra+"-"+"1".padStart(duzina,"0")+"/"+godina+", "+sifra+"-"+"2".padStart(duzina,"0")+"/"+godina+"...";
        // this.idFormatBrojaPrimer["inputControl"].nativeElement.value = format_primer;
        this.baseFormGroup.patchValue({PrimerBrojaDokumenta:format_primer});
        this.baseFormGroup.get("PrimerBrojaDokumenta").updateValueAndValidity();

        let format = sifra+"-["+"N".repeat(duzina)+"]/[GGGG]";
        this.baseFormGroup.patchValue({FormatBrojaDokumenta:format});
        this.baseFormGroup.get("FormatBrojaDokumenta").updateValueAndValidity();
        // this.idFormatBroja["inputControl"].nativeElement.value = format;
        this.primerBrojDokumenta = format_primer.split(",")[0];

    }
  }

  onSifraChange(value){
   
    let duzina = this.baseFormGroup.get('DuzinaBrojaDokumenta').value;
    let sifra= value;
    let godina = new Date().getFullYear().toString();
    if (duzina!=null && sifra!=null)
    {
        let format_primer = sifra+"-"+"1".padStart(duzina,"0")+"/"+godina+", "+sifra+"-"+"2".padStart(duzina,"0")+"/"+godina+"...";
        // this.idFormatBrojaPrimer["inputControl"].nativeElement.value = format_primer;
        this.baseFormGroup.patchValue({PrimerBrojaDokumenta:format_primer});
        this.baseFormGroup.get("PrimerBrojaDokumenta").updateValueAndValidity();

        let format = sifra+"-["+"N".repeat(duzina)+"]/[GGGG]";
        this.baseFormGroup.patchValue({FormatBrojaDokumenta:format});
        this.baseFormGroup.get("FormatBrojaDokumenta").updateValueAndValidity();
        // this.idFormatBroja["inputControl"].nativeElement.value = format;
        this.primerBrojDokumenta = format_primer.split(",")[0];

    }
  }
  onOdgovornoLiceSelect(value:Osoba){
    if (value)
      this.odgovornoLice=value.Ime+" "+value.Prezime;    
  }

  onFooterChange(value){
    this.prikaziFooter=value;
  }
  PrintTemplate(){   
    let item : PodVrstaDokumentaStavka = this.Item;
    if (item.ID >= 0){
      this.hidePrimerStampe=!this.hidePrimerStampe;
      if (this.hidePrimerStampe){
        this.primerStampeTekst="Prikaži primer";
      }
      else  
        this.primerStampeTekst="Sakrij primer";
      
      // if  (item.OdgovornoLiceID){
      //   this.baseDataService.GetByID("osoba",item.OdgovornoLiceID,Osoba)
      //     .subscribe((data)=>{
      //       this.odgovornoLice = data.Ime+" "+data.Prezime;    
      //   })
      // }
      let dateNow = new Date();
      this.datum = new NgbDate(dateNow.getFullYear(), dateNow.getMonth()+1, dateNow.getDate());
      this.prikaziDatum = this.datum.day.toString() + "." + this.datum.month.toString() + "." + this.datum.year.toString();
      // this.primerBrojDokumenta = item.PrimerBrojaDokumenta.split(",")[0];
      // if (this.primerBrojDokumenta)
      //   this.primerBrojDokumenta = this.primerBrojDokumenta.split(",")[0];
      this.changeDetectorRef.detectChanges();
    }
    else
      this.hidePrimerStampe=true;
  }

  pamtiVrednostPodVrstaDokumentID: number;
  onPodVrstaDokumentaSelect(value:PodVrstaDokumenta){
    if (value){
      if(this.pamtiVrednostPodVrstaDokumentID && this.pamtiVrednostPodVrstaDokumentID != value.ID){
        this.baseFormGroup.patchValue({DefaultIzvestajID : value.DefaultIzvestajID});
        this.baseFormGroup.get("DefaultIzvestajID").updateValueAndValidity();
      }
        this.odgovornoLiceJeObavezno = value.OdgovornoLiceJeObavezno;

        this.baseFormGroup.get("OdgovornoLiceID").clearValidators();
        if (this.odgovornoLiceJeObavezno){
          this.addValidatorToFc("OdgovornoLiceID", Validators.required, "required", "PODVRSTADOKUMENTASTAVKA.ODGOVORNOLICE.VALIDATION");
          
        }
        this.baseFormGroup.get("OdgovornoLiceID").updateValueAndValidity();
     
      this.parameterListForIzvestaj=List([]);
      this.PodVrstaDokumentaID.Name="podvrstadokumentaid";
      this.PodVrstaDokumentaID.Value=value.ID;
      this.parameterListForIzvestaj = this.parameterListForIzvestaj.push(this.PodVrstaDokumentaID)
      this.TransferParameters = this.TransferParameters.set(0, this.parameterListForIzvestaj);
      this.pamtiVrednostPodVrstaDokumentID=value.ID;
    }
  
  }

 
  onBrojDecimalaBlur(vrednost){
   this.trenutniBrojDecimala = vrednost;
  }
}

function checkBrojDecimala(_this: any, brojDecimalaKey: string){
  return (group: FormGroup): {[key: string]: any} =>{
    let brojDecimala = group.controls[brojDecimalaKey].value;
    let trenutniBrojDecimala = _this.trenutniBrojDecimala;
    

    if(brojDecimala==null && trenutniBrojDecimala==null)
      return null;
    else{
      if(brojDecimala<trenutniBrojDecimala)
        return {checkControls : {valid:false, message: 'PODVRSTADOKUMENTASTAVKA.BROJDECIMALA.VALIDATION.LESS'}};
    }
  }
}





// function CheckOdgovornoLice(odgovornoLiceIDKey: string, podVrstaDokumentaIDKey: string, mainThis: any){
//   return (group: FormGroup): {[key : string]: any} =>{
//       if (group.controls){
//         let odgovornoLiceID = group.controls[odgovornoLiceIDKey].value;
//         let podVrstaDokumentaID = group.controls[podVrstaDokumentaIDKey].value;
//         if (podVrstaDokumentaID != null){
//           mainThis.baseDataService.Get("podvrstadokumenta","get",[new QueryParameter('id',podVrstaDokumentaID)],PodVrstaDokumenta)
//                 .subscribe((data) => {
//                   mainThis.odgovornoLiceJeObavezno = data['OdgovornoLiceJeObavezno'];
//                   if (mainThis.odgovornoLiceJeObavezno && mainThis.odgovornoLiceJeObavezno == true && odgovornoLiceID == null)
//                     return { checkControls : {valid : false, message : 'PODVRSTADOKUMENTASTAVKA.ODGOVORNOLICE.VALIDATION'}};
//                   else 
//                     return null;
//                 }) 
//           // if (mainThis.odgovornoLiceJeObavezno && mainThis.odgovornoLiceJeObavezno == true && odgovornoLiceID == null)
//           //   return { checkControls : {valid : false, message : 'PODVRSTADOKUMENTASTAVKA.ODGOVORNOLICE.VALIDATION'}};
//           // else 
//           //   return null;
//         }
//         else
//           return null;
//       }

//     }
// }
